export default "__VITE_ASSET__DL8D8MzR__"